// ...existing code...
import { Injectable, isDevMode } from '@angular/core';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, from, Observable, of } from 'rxjs';
import { LoggerService } from './logger.service';
import {
  ItemDelivery,
  LegacyDeliveryRecord,
  OrderItem,
  Product,
  ProductCategory,
  ProductQuantityModel,
  Warehouse,
  WarehouseOrder,
  WarehouseRow,
  WarehouseOrderPickingActionRequest,
  WarehouseOrderPickingProgressUpdateRequest,
  WarehouseStockCheckRequest,
  WarehouseStockCheckResponse,
  DeliveryReceipt,
  CreateDeliveryReceiptRequest,
  CompanyStockResponse,
  CompanyProjectWarehousesResponse,
  WarehouseRowWithdrawalRequest,
  WarehouseRowWithdrawalResponse,
} from '../warehouse-models';
import {
  MatSnackBar,
  MatSnackBarRef,
  SimpleSnackBar,
} from '@angular/material/snack-bar';
import DataService from './data.service';
import { WarehouseApiResult } from '../WarehouseApiResult';
// import { AuthService } from './auth-service.service';
import { Project } from '../Models/project-model';
import { OAuthService } from './oauth.service';
import { environment } from 'src/environments/environment';
import {
  CreateCompanyWarehouseRequest,
  CreateCompanyWarehouseResponse,
  CreateSharedWarehouseRequest,
  AddDeliveryWithOwnerRequest
} from '../../Modules/pace-production/models/pace-package-delivery.models';

@Injectable({
  providedIn: 'root',
})
export class WarehouseDataService {
  /**
   * Add delivery and create row if it does not exist
   */
  addOrCreateDeliveryRow(delivery: ItemDelivery): Observable<ItemDelivery> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.post<ItemDelivery>(
      `${environment.apiRoot}warehouses/addOrCreateDeliveryRow`,
      delivery,
      options
    );
  }



  getQuantityData(productId: number, showDeleted:boolean) {
    return this.http.get<ProductQuantityModel>(
      `${environment.apiRoot}warehouses/ProductQuantitySummary/${productId}?showDeleted=${showDeleted}`
    );
  }
  getWaitingOrdersCount() {
    return this.http.get<number>(
      `${environment.apiRoot}warehouses/orders/waiting`
    );

  }

  /**
   * Mark an order as shipped (left the warehouse, in transit)
   * @param orderId The order ID
   * @param notes Optional notes about the shipment
   */
  shipOrder(orderId: number, notes?: string) {
    const request: WarehouseOrderPickingActionRequest = { notes };
    return this.http.post<WarehouseOrder>(`${environment.apiRoot}warehouses/orders/${orderId}/ship`, request);
  }

  /**
   * Mark an order as delivered (arrived at destination, confirmed)
   */
  deliverOrder(order: WarehouseOrder) {
    return this.http.post<WarehouseOrder>(`${environment.apiRoot}warehouses/order/deliver`, order);
  }


  warehouses!: Warehouse[];

  private readonly CART_KEY = 'ri_shop_cart';

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private store: DataService,
    private auth: OAuthService,
    private logger: LoggerService
  ) {
    this.datastore = { rows: [] };
    this._warehouserows = new BehaviorSubject<WarehouseRow[]>([]);
    this._products = new BehaviorSubject<Product[]>([]);
    this._ProductCategories = new BehaviorSubject<ProductCategory[]>([]);
    this._Projects = new BehaviorSubject<Project[]>([]);
    this._Warehouses = new BehaviorSubject<Warehouse[]>([]);
    this._Orders = new BehaviorSubject<WarehouseOrder[]>([]);
    this._DeliveredOrders = new BehaviorSubject<WarehouseOrder[]>([]);
    this._Order = new BehaviorSubject<WarehouseOrder>(new WarehouseOrder());
  }

  private datastore: any = {
    rows: [],
    Products: [],
  };
  private _products: BehaviorSubject<Product[]>;
  public get Products(): Observable<Product[]> {
    return this._products.asObservable();
  }
  private _warehouserows: BehaviorSubject<WarehouseRow[]>;

  private _Warehouses: BehaviorSubject<Warehouse[]>;
  // public get Warehouses(): Observable<Warehouse[]> {
  //   return this._Warehouses.asObservable();
  // }
public get warehouses$(): Observable<Warehouse[]> {
  return this._Warehouses.asObservable();
}
  public get warehouserows(): Observable<WarehouseRow[]> {
    return this._warehouserows.asObservable();
  }
  private _ProductCategories: BehaviorSubject<ProductCategory[]>;
  public get ProductCategories(): Observable<ProductCategory[]> {
    return this._ProductCategories.asObservable();
  }
  private _Projects: BehaviorSubject<Project[]>;
  public get Projects(): Observable<Project[]> {
    return this._Projects.asObservable();
  }
  private _Orders: BehaviorSubject<WarehouseOrder[]>;
  public get Orders(): Observable<WarehouseOrder[]> {
    return this._Orders.asObservable();
  }
  private _DeliveredOrders: BehaviorSubject<WarehouseOrder[]>;
  public get DeliveredOrders(): Observable<WarehouseOrder[]> {
    return this._DeliveredOrders.asObservable();
  }
  private _Order: BehaviorSubject<WarehouseOrder>;
  private order = new WarehouseOrder();
  public get Order(): Observable<WarehouseOrder> {
    return this._Order.asObservable();
  }
  //Load methods
  loadRows(id: number) {
    return this.http
      .get<[WarehouseRow[]]>(`${environment.apiRoot}warehouses/getrows/${id}`)
      .subscribe(
        (data) => {
          this.datastore.rows = data;

          this._warehouserows.next(Object.assign({}, this.datastore).rows);
        },
        (error) => {
          this.logger.warn('WarehouseDataService', 'failed to fetch warehouserows');
        }
      );
  }

  // Observable version for NgRx effects
  getWarehouseRows(id: number): Observable<WarehouseRow[]> {
    return this.http.get<WarehouseRow[]>(`${environment.apiRoot}warehouses/getrows/${id}`);
  }

  // loadWarehouses() {
  //   let options = {
  //     headers: new HttpHeaders().set("content-type","application/json").set("Authorization",`Bearer ${this.auth.token}`),
  //   };
  //   return this.http.get<WarehouseApiResult>("/api/warehouses",options).subscribe(
  //     (data) => {
  //       console.log("warehouses loaded: ",data.results);
  //       this.datastore.warehouses = data.results;

  //         this._Warehouses.next(Object.assign({}, this.datastore).warehouses);
  //     },
  //     (error) => {
  //       console.log('failed to get warehouses');
  //     }
  //   );
  // }
  loadWarehouses(includeDeleted: boolean = false): Observable<WarehouseApiResult> {
    return this.http.get<WarehouseApiResult>(
      `${environment.apiRoot}warehouses?includeDeleted=${includeDeleted}`
    ).pipe(tap(warehouses=>{
      this.datastore.warehouses = warehouses.results;
      this._Warehouses.next(Object.assign({}, this.datastore).warehouses);
    }));
  }

  /**
   * Get destination warehouses the current user is eligible to ship orders to.
   * Permission scoping is handled server-side:
   * - CanManageWarehouses → all destinations (optionally filtered by projectId)
   * - CanReadPaceProductionWarehouses → only destinations connected to projects the user is assigned to
   * @param projectId Optional — restrict results to a single project
   */
  getDestinations(projectId?: number): Observable<WarehouseApiResult> {
    const url = projectId
      ? `${environment.apiRoot}warehouses/destinations?projectId=${projectId}`
      : `${environment.apiRoot}warehouses/destinations`;
    return this.http.get<WarehouseApiResult>(url);
  }

  /**
   * Get warehouses with optional includeDeleted filter
   * @param includeDeleted Whether to include soft-deleted warehouses (default: false)
   */
  getWarehouses(includeDeleted: boolean = false): Observable<Warehouse[]> {
    return this.http.get<Warehouse[]>(`${environment.apiRoot}warehouses?includeDeleted=${includeDeleted}`);
  }
  // warehouses$() {
  //   return this.http.get<Warehouse[]>(environment.apiRoot + 'warehouses');
  // }
  loadProducts() {
    return this.http.get<[Product[]]>(`${environment.apiRoot}warehouses/getProducts`).subscribe(
      (data: any) => {
        this.datastore.Products = data;
        this.logger.debug('WarehouseDataService', 'Products loaded', data);
        this._products.next(Object.assign({}, this.datastore).Products);
      },
      (error) => {
        this.logger.warn('WarehouseDataService', 'failed to fetch products');
      }
    );
  }

  DbProducts() {
    return this.http.get<Product[]>(`${environment.apiRoot}warehouses/getProducts`);
  }
  getProduct(id: number): Observable<Product> {
    if (id === 0) {
      return of(new Product());
    } else {
      return this.http.get<any>(`${environment.apiRoot}warehouses/getproduct/${id}`);
    }
  }
  loadCategories() {
    this.auth.getAccessToken().then((token) => {
      let options = {
        headers: new HttpHeaders()
          .set('content-type', 'application/json')
          .set('Authorization', `Bearer ${token}`),
      };
      return this.http
        .get<[Product[]]>(`${environment.apiRoot}warehouses/getcategories`)
        .subscribe(
          (data) => {
            this.datastore.ProductCategories = data;

            this._ProductCategories.next(
              Object.assign({}, this.datastore).ProductCategories
            );
          },
          (error) => {
            this.logger.warn('WarehouseDataService', 'failed to fetch categories');
          }
        );
    });
  }
  loadProjects() {
    this.auth.getAccessToken().then((token) => {
      let options = {
        headers: new HttpHeaders()
          .set('content-type', 'application/json')
          .set('Authorization', `Bearer ${token}`),
      };
      return this.http
        .get<[Project[]]>(environment.apiRoot + 'projects', options)
        .subscribe(
          (data) => {
            this.datastore.Projects = data;

            this._Projects.next(Object.assign({}, this.datastore).Projects);
          },
          (error) => {
            this.logger.warn('WarehouseDataService', 'failed to fetch projects!');
          }
        );
    });
  }

  loadOrders() {
    return this.http
      .get<WarehouseOrder[]>(`${environment.apiRoot}warehouses/orders`)
      .subscribe((data) => {
        this.logger.debug('WarehouseDataService', 'Orders loaded: ', data);
        this.datastore.Orders = data;
        this._Orders.next(Object.assign({}, this.datastore).Orders);
      });
  }

  loadDeliveredOrders(params?: { projectId?: number; companyId?: string; originWarehouseId?: number; from?: string; to?: string }) {
    const query = new URLSearchParams();
    if (params?.projectId) query.set('projectId', String(params.projectId));
    if (params?.companyId) query.set('companyId', params.companyId);
    if (params?.originWarehouseId) query.set('originWarehouseId', String(params.originWarehouseId));
    if (params?.from) query.set('from', params.from);
    if (params?.to) query.set('to', params.to);
    const qs = query.toString() ? `?${query.toString()}` : '';
    return this.http
      .get<WarehouseOrder[]>(`${environment.apiRoot}warehouses/orders/delivered${qs}`)
      .subscribe((data) => {
        this._DeliveredOrders.next(data);
      });
  }
  getOrders() {
    return this.http
      .get<WarehouseOrder[]>(`${environment.apiRoot}warehouses/orders`);
  }

  /**
   * Get a single order by ID with full details
   */
  getOrderById(orderId: number) {
    return this.http.get<WarehouseOrder>(
      `${environment.apiRoot}warehouses/orders/${orderId}`
    );
  }

  /**
   * Start picking process for an order
   * Sets pickingStarted flag on the backend
   */
  startPicking(orderId: number, request: WarehouseOrderPickingActionRequest = {}) {
    return this.http.post<WarehouseOrder>(
      `${environment.apiRoot}warehouses/orders/${orderId}/picking/start`,
      request
    );
  }

  /**
   * Mark order as ready for delivery
   * Requires picking to have been started first
   */
  markReadyForDelivery(orderId: number, request: WarehouseOrderPickingActionRequest = {}) {
    return this.http.post<WarehouseOrder>(
      `${environment.apiRoot}warehouses/orders/${orderId}/picking/ready`,
      request
    );
  }

  /**
   * Check if origin warehouse has sufficient stock for the given items
   */
  checkStock(request: WarehouseStockCheckRequest) {
    return this.http.post<WarehouseStockCheckResponse>(
      `${environment.apiRoot}warehouses/orders/check-stock`,
      request
    );
  }

  /**
   * Update picking progress - persists per-item picked quantities
   * Server clamps pickedQuantity to [0, item.quantity]
   * If order was previously marked ready, this clears readyForDelivery fields
   */
  updatePickingProgress(orderId: number, request: WarehouseOrderPickingProgressUpdateRequest) {
    return this.http.post<WarehouseOrder>(
      `${environment.apiRoot}warehouses/orders/${orderId}/picking/progress`,
      request
    );
  }

  /**
   * Pick all items at once - sets each item's pickedQuantity = quantity
   */
  pickAll(orderId: number, request: WarehouseOrderPickingActionRequest = {}) {
    return this.http.post<WarehouseOrder>(
      `${environment.apiRoot}warehouses/orders/${orderId}/picking/pick-all`,
      request
    );
  }

  /**
   * Reset picking - resets all item picked quantities to 0 and clears
   * pickingStarted* / readyForDelivery* fields
   */
  resetPicking(orderId: number, request: WarehouseOrderPickingActionRequest = {}) {
    return this.http.post<WarehouseOrder>(
      `${environment.apiRoot}warehouses/orders/${orderId}/picking/reset`,
      request
    );
  }

  //POST methods
  addRow(warehouserow: WarehouseRow): Observable<WarehouseRow> {
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.post<WarehouseRow>(
      `${environment.apiRoot}warehouses/addwarehouserow`,
      warehouserow,
      options
    );
  }

  updateWarehouseRow(warehouserow: WarehouseRow): Observable<WarehouseRow> {
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.put<WarehouseRow>(
      `${environment.apiRoot}warehouses/updatewarehouserow`,
      warehouserow,
      options
    );
  }

  addDelivery(delivery: ItemDelivery): Observable<ItemDelivery> {
    // Add Database saveing and update only after save successful
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.post<ItemDelivery>(
      `${environment.apiRoot}warehouses/addDelivery`,
      delivery,
      options
    );
  }
  addTransfer(delivery: ItemDelivery): Observable<ItemDelivery> {
    // Validate transfer data
    if (!delivery.destinationId || delivery.destinationId === 0) {
      throw new Error('Destination warehouse is required');
    }
    if (!delivery.quantity || delivery.quantity === 0) {
      throw new Error('Transfer quantity must be greater than zero');
    }
    if (!delivery.productId) {
      throw new Error('Product ID is required');
    }
    if (!delivery.rowId) {
      throw new Error('Source warehouse row is required');
    }

    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.post<ItemDelivery>(
      `${environment.apiRoot}warehouses/addTransfer`,
      delivery,
      options
    );
  }
  /**
   * Withdraws stock from a warehouse row and records it as a project material delivery.
   * Requires CanWithdrawStock or CanManageWarehouses permission.
   */
  withdrawStock(
    warehouseId: number,
    rowId: number,
    request: WarehouseRowWithdrawalRequest
  ): Observable<WarehouseRowWithdrawalResponse> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.post<WarehouseRowWithdrawalResponse>(
      `${environment.apiRoot}warehouses/${warehouseId}/rows/${rowId}/withdraw`,
      request,
      options
    );
  }

  addProduct(Product: Product): Observable<Product> {

    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.post<Product>(
      `${environment.apiRoot}warehouses/addProduct`,
      Product,
      options
    );
  }
  updateProduct(product: Product) {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    const url = `${environment.apiRoot}warehouses/updateproduct`;
    return this.http.put<Product>(url, product, options);
  }
  deleteProduct(productId: number) {
    return this.http.delete(
      `${environment.apiRoot}warehouses/DeleteProduct?productId=${productId}`
    );
  }
  getCategory(id: number): Observable<ProductCategory> {
    return this.http.get<ProductCategory>(
      `${environment.apiRoot}warehouses/getcategory/${id}`
    );
  }
  addCategory(category: ProductCategory): Observable<ProductCategory> {
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.post<ProductCategory>(
      `${environment.apiRoot}warehouses/addcategory`,
      category,
      options
    );
  }
  updateCategory(category: ProductCategory) {
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.put<ProductCategory>(
      `${environment.apiRoot}warehouses/updatecategory/${category.id}`,
      category,
      options
    );
  }
  /**
   * Get a single warehouse by ID
   * @param id Warehouse ID
   * @param includeDeleted Whether to include soft-deleted warehouses (default: false)
   */
  getWarehouse(id: number, includeDeleted: boolean = false) {
    return this.http.get<Warehouse>(`${environment.apiRoot}warehouses/${id}?includeDeleted=${includeDeleted}`);
  }
  addWarehouse(warehouse: Warehouse): Observable<Warehouse> {
    return this.http.post<Warehouse>(`${environment.apiRoot}warehouses`, warehouse);
  }

  /**
   * Create a warehouse for a company at a specific project.
   * Used when delivery readiness check finds no origin warehouse for a PacePackage.
   *
   * The warehouse is created as a source warehouse (destinationOnly = false)
   * that can be used as the origin for warehouse orders.
   *
   * @param request Project ID, company ID, and optional warehouse name
   * @returns The created (or existing) warehouse info
   */
  createCompanyWarehouse(request: CreateCompanyWarehouseRequest): Observable<CreateCompanyWarehouseResponse> {
    return this.http.post<CreateCompanyWarehouseResponse>(
      `${environment.apiRoot}warehouses/create-company-warehouse`,
      request
    );
  }

  /**
   * Create a shared warehouse for a project.
   * Shared warehouses allow multiple companies to use the same warehouse as a source.
   * Stock ownership is tracked at the row level using WarehouseRow.OwnerCompanyId.
   *
   * @param request Project ID, optional owner company, and optional warehouse name
   * @returns The created (or existing) warehouse info
   */
  createSharedWarehouse(request: CreateSharedWarehouseRequest): Observable<CreateCompanyWarehouseResponse> {
    return this.http.post<CreateCompanyWarehouseResponse>(
      `${environment.apiRoot}warehouses/create-shared-warehouse`,
      request
    );
  }

  /**
   * Add stock to a shared warehouse with row-level company ownership.
   * Only packages from the owning company can use this stock.
   *
   * @param request Warehouse ID, product, owner company, amount, and optional delivery details
   * @returns Delivery confirmation
   */
  addDeliveryWithOwner(request: AddDeliveryWithOwnerRequest): Observable<any> {
    return this.http.post(
      `${environment.apiRoot}warehouses/adddelivery-with-owner`,
      request
    );
  }

  /**
   * Get stock for a specific company in a shared warehouse.
   * Returns the response wrapper including warehouse metadata and rows owned by the company.
   *
   * @param warehouseId Warehouse ID
   * @param companyId Company GUID
   */
  getCompanyStockInWarehouse(warehouseId: number, companyId: string): Observable<CompanyStockResponse> {
    return this.http.get<CompanyStockResponse>(
      `${environment.apiRoot}warehouses/${warehouseId}/stock/${companyId}`
    );
  }

  /**
   * Get warehouses for a specific company at a project (including shared warehouses).
   * Useful for finding the origin warehouse for a PacePackage.
   *
   * @param companyId Company GUID
   * @param projectId Project ID
   */
  getWarehousesByCompanyAndProject(companyId: string, projectId: number): Observable<CompanyProjectWarehousesResponse> {
    return this.http.get<CompanyProjectWarehousesResponse>(
      `${environment.apiRoot}warehouses/company/${companyId}/project/${projectId}`
    );
  }

  updateWarehouse(warehouse: Warehouse) {
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };
    return this.http.put<Warehouse>(
      `${environment.apiRoot}warehouses/${warehouse.id}`,
      warehouse,
      options
    );
  }
  /**
   * Delete a warehouse
   * @param warehouseId Warehouse ID to delete
   * @param hardDelete If true, permanently removes the warehouse. Default is soft delete.
   */
  deleteWarehouse(warehouseId: number, hardDelete: boolean = false) {
    return this.http.delete(
      `${environment.apiRoot}warehouses/${warehouseId}?hardDelete=${hardDelete}`
    );
  }
  deleteWarehouseRow(rowId: number) {
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    return this.http.delete(
      `${environment.apiRoot}warehouses/deleterow/${rowId}`
    );
  }
  addOrder(order: WarehouseOrder): Observable<WarehouseOrder> {
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    return this.http.post<WarehouseOrder>(
      `${environment.apiRoot}warehouses/orders/add`,
      order,
      options
    );
  }

  /**
   * Updates an existing order on the server.
   * Note: originId and destinationId cannot be changed after order creation.
   * If order was previously marked ready, update will clear readyForDelivery fields.
   */
  saveOrderUpdate(order: WarehouseOrder): Observable<WarehouseOrder> {
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    return this.http.put<WarehouseOrder>(
      `${environment.apiRoot}warehouses/orders/${order.id}`,
      order,
      options
    );
  }

  addToOrder(item: OrderItem) {
    let orderItem: OrderItem | undefined;
    orderItem = this.order.items.find((o) => o.deliveryItemId === item.deliveryItemId);

    if (orderItem) {
      orderItem.quantity += item.quantity;
      this.openSnackBar('Tuote lisätty!');
    } else {
      this.order.items.push(item);
      this.openSnackBar('Uusi tuote lisätty');
    }
    this._Order.next(Object.assign({}, this.order));
    this._persistCart();
  }
  removeFormOrder(item: OrderItem) {
    this.order.items = this.order.items.filter(
      (OrderItem) => OrderItem.deliveryItemId !== item.deliveryItemId
    );

    this._Order.next(Object.assign({}, this.order));
    this._persistCart();
  }
  updateOrder(order: WarehouseOrder) {
    this.order = order;
    this._Order.next(Object.assign({}, this.order));
    this._persistCart();
  }
  saveOrder() {
    return this.addOrder(this.order);
  }
  initOrder(Origin: Warehouse) {
    const draft = this._restoreCart(Origin.id);
    if (draft) {
      this.order = draft;
      this.order.origin = Origin;
    } else {
      this.order = new WarehouseOrder();
      this.order.originId = Origin.id;
      this.order.origin = Origin;
    }
    this._Order.next(Object.assign({}, this.order));
  }
  resetOrder(Origin: Warehouse) {
    if (Origin.id !== this.order.originId) {
      this._clearCart();
      this.order = new WarehouseOrder();
      this.order.originId = Origin.id;
      this.order.origin = Origin;
      this._Order.next(Object.assign({}, this.order));
    }
  }
  deleteOrder(id: Number) {
    let options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    };

    return this.http.delete<WarehouseOrder>(
      `${environment.apiRoot}warehouses/orders/delete/${id}`
    );
  }
  getAIProductCategory(productName:string){
    return this.http.post<any>(`${environment.apiRoot}product/getCategory`, { productName: productName });
  }

  private _persistCart(): void {
    try {
      sessionStorage.setItem(this.CART_KEY, JSON.stringify({
        originId: this.order.originId,
        items: this.order.items,
      }));
    } catch { /* quota or private browsing — silently ignore */ }
  }

  private _clearCart(): void {
    sessionStorage.removeItem(this.CART_KEY);
  }

  private _restoreCart(warehouseId: number): WarehouseOrder | null {
    try {
      const raw = sessionStorage.getItem(this.CART_KEY);
      if (!raw) return null;
      const data = JSON.parse(raw);
      if (data.originId !== warehouseId || !Array.isArray(data.items) || data.items.length === 0) return null;
      const order = new WarehouseOrder();
      order.originId = data.originId;
      order.items = data.items.map((i: any) => {
        const item = new OrderItem();
        return Object.assign(item, i);
      });
      return order;
    } catch {
      return null;
    }
  }
  openSnackBar(message: string): MatSnackBarRef<SimpleSnackBar> {
    return this.snackBar.open(message, '', { duration: 3000 });
  }

  // ── Delivery Receipts ────────────────────────────────────────────────────

  createDeliveryReceipt(receipt: CreateDeliveryReceiptRequest): Observable<DeliveryReceipt> {
    return this.http.post<DeliveryReceipt>(`${environment.apiRoot}warehouses/delivery-receipts`, receipt);
  }

  getDeliveryReceipts(warehouseId: number): Observable<DeliveryReceipt[]> {
    return this.http.get<DeliveryReceipt[]>(`${environment.apiRoot}warehouses/${warehouseId}/delivery-receipts`);
  }

  getDeliveryReceiptById(receiptId: number): Observable<DeliveryReceipt> {
    return this.http.get<DeliveryReceipt>(`${environment.apiRoot}warehouses/delivery-receipts/${receiptId}`);
  }

  getDeliveryReceiptsForOrder(orderId: number): Observable<DeliveryReceipt[]> {
    return this.http.get<DeliveryReceipt[]>(`${environment.apiRoot}warehouses/orders/${orderId}/delivery-receipts`);
  }

  acceptDeliveryReceipt(receiptId: number): Observable<DeliveryReceipt> {
    return this.http.post<DeliveryReceipt>(`${environment.apiRoot}warehouses/delivery-receipts/${receiptId}/accept`, {});
  }

  updateDeliveryReceiptDraft(receiptId: number, receipt: CreateDeliveryReceiptRequest): Observable<DeliveryReceipt> {
    return this.http.put<DeliveryReceipt>(`${environment.apiRoot}warehouses/delivery-receipts/${receiptId}`, receipt);
  }

  getSupplierSuggestions(warehouseId: number): Observable<string[]> {
    return this.http.get<string[]>(`${environment.apiRoot}warehouses/${warehouseId}/suppliers`);
  }

  getProductByBarcode(barcode: string): Observable<Product | null> {
    return this.http.get<Product>(`${environment.apiRoot}warehouses/products/barcode/${encodeURIComponent(barcode)}`);
  }

  /** Get flat list of all legacy (old-style) deliveries and transfers for a warehouse */
  getItemDeliveriesForWarehouse(warehouseId: number): Observable<LegacyDeliveryRecord[]> {
    return this.http.get<LegacyDeliveryRecord[]>(`${environment.apiRoot}warehouses/${warehouseId}/item-deliveries`);
  }
}
